// dependencies
import PropTypes from "prop-types";
import React, { useState } from "react";

import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";

// components
import TextInput from "../../../../components/Inputs/InputText";

// styles
import css from "../Teams.module.scss";

const Search = (props) => {
	const [search, setSearch] = useState("");
	const handleSearch = (value) => {
		setSearch(value);
		props.updateSearch(value);
	};

	return (
		<div className={css.searchTool}>
			<TextInput
				onEnter={handleSearch}
				icon={faMagnifyingGlass}
				className={css.searchField}
				onChange={handleSearch}
				value={search}
				placeholder="Search for a team..."
			/>
		</div>
	);
};

Search.propTypes = {
	updateSearch: PropTypes.func.isRequired,
};

export default Search;
